import React, { useState, useEffect, useCallback } from 'react';
import { ChevronLeftIcon, ChevronRightIcon } from '@heroicons/react/solid';
import { Link } from "react-router-dom";




const Carousel = ({ events }) => {
    const [currentEventIndex, setCurrentEventIndex] = useState(0);
    const [autoplay, setAutoplay] = useState(true);

    const calculateHeight = () => {
        if (window.innerWidth >= 768) {
            return { height: 'calc(100vw / 3)' };
        } else {
            return { height: 'calc(100vw / 1.7)' };
        }
    };

    const [carouselStyle, setCarouselStyle] = useState(calculateHeight());

    const goToNextEvent = useCallback(() => {
        const nextIndex = (currentEventIndex + 1) % events[0].length;
        setCurrentEventIndex(nextIndex);
    }, [currentEventIndex, events]);

    const goToPreviousEvent = useCallback(() => {
        const previousIndex = (currentEventIndex - 1 + events[0].length) % events[0].length;
        setCurrentEventIndex(previousIndex);
    }, [currentEventIndex, events]);

    useEffect(() => {
        let interval;
        if (autoplay) {
            interval = setInterval(goToNextEvent, 6000);
        }

        return () => clearInterval(interval);
    }, [autoplay, goToNextEvent]);

    useEffect(() => {
        const handleResize = () => {
            setCarouselStyle(calculateHeight());
        };

        window.addEventListener('resize', handleResize);
        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    return (
        <div className='bg-background'>
            <div className="relative mx-auto w-full" style={carouselStyle}>
                {events[0].map((event, index) => (
                    <div
                    key={index}
                    className={`absolute w-full h-full transition-opacity duration-500 ${index === currentEventIndex ? 'opacity-100' : 'opacity-0 pointer-events-none'
                        }`}
                    style={{ zIndex: index === currentEventIndex ? 10 : 1 }}
                >
                    <img
                        src={event.image}
                        alt={event.title}
                        className="absolute w-full h-full object-cover"
                    />
        
                    {/* Chevron icons positioned absolutely within the image container */}
                    {index === currentEventIndex && (
                        <React.Fragment>
                            <ChevronLeftIcon
                                color="white"
                                width={60}
                                height={40}
                                className="absolute top-1/2 -translate-y-1/2 left-4 cursor-pointer z-20"
                                onClick={(e) => {
                                    e.stopPropagation(); // Stop event propagation
                                    goToPreviousEvent();
                                }}
                            />
                            <ChevronRightIcon
                                color="white"
                                width={60}
                                height={40}
                                className="absolute top-1/2 -translate-y-1/2 right-4 cursor-pointer z-20"
                                onClick={(e) => {
                                    e.stopPropagation(); // Stop event propagation
                                    goToNextEvent();
                                }}
                            />
                        </React.Fragment>
                    )}
                        <div className="absolute bottom-7 mx-8 text-white">
                            <h2 className="text-2xl font-text my-1 font-bold">{event.title}</h2>
                            <p className="font-text text-sm">{event.date} | {event.location}</p>
                            <Link
                                to="/purchase"
                                onClick={() => {
                                    window.scroll(0, 0);
                                }}
                            >
                                <button className="bg-blue font-text text-white px-3 py-1 mt-2 rounded-md">
                                    Purchase Tickets (from {event.price}$)
                                </button>
                            </Link>

                        </div>
                        <div className="absolute bottom-5 left-0 right-0 flex justify-center items-center">
                            {events[0].map((_, index) => (
                                <div
                                    key={index}
                                    className={`w-2 h-2 mx-1 rounded-full ${index === currentEventIndex ? 'bg-blue' : 'bg-white'
                                        }`}
                                ></div>
                            ))}
                        </div>

                    </div>
                ))}

            </div>
        </div>

    );
};

export default Carousel;

